import React from 'react'
import { Helmet } from 'react-helmet-async'
import { useAuthStore } from '../store/authStore'
import { useNavigate } from 'react-router-dom'

function DashboardPage() {
  const { user, logout } = useAuthStore()
  const navigate = useNavigate()

  const handleLogout = () => {
    logout()
    navigate('/')
  }

  if (!user) {
    navigate('/login')
    return null
  }

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <Helmet><title>Dashboard | 1688 Deutschland</title></Helmet>
      <div className="bg-white shadow rounded-lg p-6">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold text-gray-900">Mein Konto</h1>
          <button onClick={handleLogout} className="text-red-600 hover:text-red-700">Abmelden</button>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="p-4 border rounded-lg">
            <h2 className="font-semibold mb-2">Profil</h2>
            <p className="text-gray-600">Name: {user.name}</p>
            <p className="text-gray-600">Email: {user.email}</p>
          </div>
          <div className="p-4 border rounded-lg">
            <h2 className="font-semibold mb-2">Bestellungen</h2>
            <p className="text-gray-600">Keine aktuellen Bestellungen.</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DashboardPage